<template>
    <v-card class="pb-5">
        <v-card-title>
            <span class="text-h5"><span v-if="is_backcountrysafary">Delivery</span> Address</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('modal-close')"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-container>
            <div class="mt-5" >
                <v-col offset-md="1" cols="12" md="10">
                    <v-text-field label="Property Name" v-model="reservation.delivery_property_name" ></v-text-field>
                    <v-text-field label="Property Address" v-model="reservation.delivery_address" ></v-text-field>
                </v-col>
                <v-col offset-md="1" cols="12" md="10" style="text-align: right">
                    <v-btn @click="Close">Close</v-btn>
                    <v-btn class="ml-2" color="primary" @click="Save">Save</v-btn>
                </v-col>
            </div>
        </v-container>
    </v-card>
</template>

<script>
import axios                 from "axios";
import StepperComponentMixin from "../../mixins/StepperComponentMixin";

export default {
    name  : "DialogDeliveryAddress",
    mixins: [StepperComponentMixin],
    data  : () => ({

    }),
    computed: {
        reservation() {
            return this.$store.state.model.reservation;
        },
        is_backcountrysafary(){
            if(this.$store.state.resources.config.frontend_view_folder=="frontend.backcountrysafary" && !window.location.href.includes("delivery")){
                return false;
            }
            return true;
        }
    },
    methods:{
        Close(){
            this.$store.commit('set_model_value',{path:'model.reservation.delivery_property_name',value: "" });
            this.$store.commit('set_model_value',{path:'model.reservation.delivery_address',value: "" })
            this.$emit('modal-close');
        },
        Save(){
            this.$emit('modal-close');
        }
    }
}
</script>

<style scoped>

</style>
